import React, { useMemo } from "react";
import { Grid, IconButton, Typography, makeStyles } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIcon from "@material-ui/icons/ArrowForwardIos";
import { useConfigs } from "../config-provider";
var useStyles = makeStyles(function (theme) {
  return {
    title: {
      padding: theme.spacing(1, 2),
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    date: {
      padding: theme.spacing(1, 1, 0)
    },
    header: {
      padding: theme.spacing(1.5, 2, 0)
    },
    hidden: {
      visibility: "hidden"
    },
    arrow: {
      padding: 4
    }
  };
});

var CalendarHeader = function CalendarHeader(_a) {
  var month = _a.month,
      startDate = _a.startDate,
      endDate = _a.endDate,
      onChange = _a.onChange;
  var locale = useConfigs().locale;
  var classes = useStyles();
  var previousMonth = useMemo(function () {
    return month.clone().subtract(1, "months");
  }, [month]);
  var nextMonth = useMemo(function () {
    return month.clone();
  }, [month]);
  return React.createElement(Grid, null, React.createElement(Grid, {
    container: true,
    className: classes.title
  }, React.createElement(Grid, {
    item: true,
    xs: true,
    className: classes.date
  }, React.createElement(Typography, {
    variant: "body1"
  }, locale.DateRange.startDate), React.createElement(Typography, {
    variant: "h5",
    color: "inherit"
  }, startDate ? startDate.format("M/D/YYYY") : "--")), React.createElement(Grid, {
    item: true,
    xs: true,
    className: classes.date
  }, React.createElement(Typography, {
    variant: "body1"
  }, locale.DateRange.endDate), React.createElement(Typography, {
    variant: "h5",
    color: "inherit"
  }, endDate ? endDate.format("M/D/YYYY") : "--"))), React.createElement(Grid, {
    container: true,
    className: classes.header
  }, React.createElement(Grid, {
    container: true,
    item: true,
    xs: true
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    size: "small",
    onClick: function onClick() {
      return onChange(month.clone().subtract(1, "months"));
    }
  }, React.createElement(ArrowBackIcon, {
    className: classes.arrow
  }))), React.createElement(Grid, {
    container: true,
    item: true,
    xs: true,
    justify: "center",
    alignItems: "center"
  }, React.createElement(Typography, null, previousMonth.format("MMMM YYYY"))), React.createElement(Grid, {
    item: true,
    className: classes.hidden
  }, React.createElement(IconButton, {
    size: "small"
  }, React.createElement(ArrowForwardIcon, {
    fontSize: "small"
  })))), React.createElement(Grid, {
    container: true,
    item: true,
    xs: true
  }, React.createElement(Grid, {
    item: true,
    className: classes.hidden
  }, React.createElement(IconButton, {
    size: "small"
  }, React.createElement(ArrowBackIcon, {
    fontSize: "small"
  }))), React.createElement(Grid, {
    container: true,
    item: true,
    xs: true,
    justify: "center",
    alignItems: "center"
  }, React.createElement(Typography, null, nextMonth.format("MMMM YYYY"))), React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    size: "small",
    onClick: function onClick() {
      return onChange(month.clone().add(1, "months"));
    }
  }, React.createElement(ArrowForwardIcon, {
    className: classes.arrow
  }))))));
};

export default CalendarHeader;